<template>
	
<div class="improve">

	<div class="improve-title">{{ section.summary.improve.title }}</div>

	<div class="improve-section" :data-name="subsection" v-for="subsection in subsections" :key="subsection">

		<div class="improve-section-title">{{ improve[subsection].title_summary }}</div>
		<div class="improve-section-links">

			<span v-if="subsection === 'treatment'">See details later for your recommendation.</span>

			<span v-for="(link, index) in improve[subsection].links" :key="index">{{ link.text }}<template v-if="link.print"> ({{link.print}})</template></span>

			<span v-if="subsection === 'supplements' && hasSupplementText">{{ hasSupplementText }}</span>

		</div>

	</div>

</div>

</template>

<script>

export default {

	props: ['section'],

	data: function() {

		return {

			supplements: {
				1: 'It is recommended that your GP prescribe calcium supplements',
				2: 'It is recommended that your GP prescribe calcium and vitamin D supplements',
				3: 'It is recommended that yYour GP prescribe Vitamin D supplements',
				4: 'It is recommended that you take over the counter calcium supplements',
				5: 'It is recommended that you take over the counter calcium and vitamin D supplements',
				6: 'It is recommended that you take over the counter Vitamin D supplements'
			}

		}
	},

	computed: {

		hasSupplementText: function() {

			return (this.$getValue('aid.treatment') && this.$getValue('aid.supplements.recommended') === 1) ? this.supplements[this.$getValue('aid.supplements.action')] : false

		},

		selected: function() {

			return this.$store.getters['logic/variable'](this.$store.getters['data/setup'].treatments.variable)

		},

		hasNone: function() {

			return this.$_.contains(this.selected, 0)

		},

		subsections: function() {
			
			return (this.$getValue('aid.treatment')) ? ['treatment', 'diet', 'supplements', 'habits', 'activity', 'stress'] : ['diet', 'supplements', 'habits', 'activity', 'stress']

		},

		improve: function() {

			return this.$_.findWhere(this.$store.getters['data/aid/sections'], {
				id: 4
			})

		}

	}
	
}

</script>

<style scoped>

.improve {
	border-bottom: 1px solid var(--aid-color);
	margin-bottom: 32px;
}

.is-pdf .improve {
	border-bottom: 0px;
	margin-bottom: 0px;
}

.improve-title {
	color: #343434;
	margin-bottom: 32px;
	font-size: 20px;
	text-transform: uppercase;
	font-weight: 600;
}

.is-pdf .improve-title {
	margin-bottom: 20px;
	font-size: 16px;
}

.improve-section {
	margin-bottom: 32px;
	background-position: 0px 0px;
	background-size: auto 48px;
	min-height: 48px;
	background-repeat: no-repeat;
	padding-left: 96px;
}

.is-pdf .improve-section {
	margin-bottom: 20px;
}


.improve-section[data-name="diet"] { background-image: url(~@/assets/aid/improve/icon.diet.svg); }
.improve-section[data-name="treatment"] { background-image: url(~@/assets/aid/improve/icon.treatment.svg); }
.improve-section[data-name="supplements"] { background-image: url(~@/assets/aid/improve/icon.supplements.svg); }
.improve-section[data-name="stress"] { background-image: url(~@/assets/aid/improve/icon.stress.svg); }
.improve-section[data-name="habits"] { background-image: url(~@/assets/aid/improve/icon.habits.svg); }
.improve-section[data-name="activity"] { background-image: url(~@/assets/aid/improve/icon.activity.svg); }

.improve-section-title {
	color: #343434;
	font-weight: 600;
	font-size: 20px;
	width: 400px;
	margin-bottom: 4px;
}

.is-pdf .improve-section-title {
	font-size: 14px;
}

.improve-section-links {
	font-size: 18px;
	line-height: 20px;
	font-weight: 300;
	color: #343434;
}

.is-pdf .improve-section-links {
	font-size: 14px;
	line-height: 16px;
}

.improve-section-links span {
	display: block;
}

</style>